function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "inherit",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Creation-Form---No-slots-found",
  transform: "translate(-794.000000, -419.000000)",
  fill: "inherit"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(653.000000, 406.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.287235,22.6622359 C140.912234,23.0059876 140.904421,23.3575466 141.263798,23.7169234 C141.623175,24.0763002 141.974734,24.0684878 142.318485,23.6934859 L146.49036,19.5684859 L150.662235,23.6934859 C151.005987,24.0684878 151.35755,24.0763002 151.71692,23.7169234 C152.0763,23.3575466 152.06849,23.0059876 151.69348,22.6622359 L147.568485,18.4903609 L151.69348,14.3184859 C152.06849,13.9747339 152.0763,13.6231709 151.71692,13.2638009 C151.35755,12.9044209 151.005987,12.9122309 150.662235,13.2872409 L146.49036,17.4122359 L142.318485,13.2872409 C141.974734,12.9122309 141.623175,12.9044209 141.263798,13.2638009 C140.904421,13.6231709 140.912234,13.9747339 141.287235,14.3184859 L145.412235,18.4903609 L141.287235,22.6622359 Z",
  id: "right-icon"
}))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5a6dd075.svg";
export { ForwardRef as ReactComponent };